import Header from "@components/Header/Header"
import { JagadLogo } from "@components/JagadLogo/JagadLogo"
import PINInput from "@components/PINInput/PINInput"
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router'
import { useEffect, useState } from 'react'
import {
  Container,
  ContentContainer,
  Title,
  Description,
  PINContainer
} from './PINLock.styles.tsx'
import { useBiometricsStore } from '../../stores/biometricsStore'
import { Biometrics, setHeaderColor } from "@lib/telegram.ts"
import { WHITE } from "@styles/colors.ts"

const PINLock = () => {
    const { t } = useTranslation()
    const { isEnabled } = useBiometricsStore()
    const { resetInactivity } = useAuth()
    const navigate = useNavigate()
    const [unlocking, setUnlocking] = useState(false)

    useEffect(() => {
        const onBiometricSuccess = () => {
            resetInactivity()
            navigate('/home')
        }

        const onBiometricFailure = () => {
            navigate('/pin-lock')
        }

        if (isEnabled) {
            Biometrics.requestBiometricsAuth(onBiometricSuccess, onBiometricFailure)
        }
    }, [isEnabled])
    
    // Redirect to home after successful unlock
    useEffect(() => {
        if (unlocking) {
            const redirectTimer = setTimeout(() => {
                navigate('/home')
            }, 100) // Short delay to ensure state updates are processed
            
            return () => clearTimeout(redirectTimer)
        }
    }, [unlocking, navigate])
    
    const handlePinComplete = async ({ success }: { success: boolean }) => {
        if (success) {
            try {
                // First set unlocking state to trigger the redirect effect
                setUnlocking(true)
                
                // Reset inactivity state
                resetInactivity()
            } catch (error) {
                setUnlocking(false)
            }
        }
    }

    useEffect(() => {
        setHeaderColor(WHITE)
    }, [])
    
    return (
        <Container>
            <Header>
                <JagadLogo type="logo-color-text-black" />
            </Header>
            <ContentContainer>
                <Title>{t('components.lock.title')}</Title>
                <Description>
                    {t('components.lock.description')}
                </Description>
            </ContentContainer>
            <PINContainer>
                <PINInput
                    minimalStyle={true}
                    enableTitle={false}
                    enableDescription={false}
                    mode="validate"
                    onComplete={handlePinComplete}
                />
            </PINContainer>
        </Container>
    )
}

export default PINLock
